import { IndicationItem } from 'features/indicationTriage'
import { createContext, Dispatch, SetStateAction, useContext } from 'react'
import {
  GeckoComponentShape,
  GeckoFeature,
  GeckoMarkupLayer,
  GeckoMarkupPrimitive,
} from 'types'

type UpdateIndicationContextType = {
  updateOrAddIndication?: (indication: IndicationItem) => void
  setSelection?: Dispatch<
    SetStateAction<
      | GeckoComponentShape
      | GeckoMarkupLayer
      | GeckoMarkupPrimitive
      | GeckoFeature
      | undefined
    >
  >
  refreshIndications: () => Promise<void>
}
export const UpdateIndicationContext =
  createContext<UpdateIndicationContextType>({
    refreshIndications: () => Promise.resolve(),
  })

export function useUpdateIndicationContext(): UpdateIndicationContextType {
  return useContext(UpdateIndicationContext)
}
